// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CXqU","index":"styles_index__1aHE9"};